<template>
    <div style="min-height:550px;background-color:#000;">
        <div class="banner">
            <div class="banner-background">
                <div class="banner-content">
                    <p class="p-one">网页取证</p>
                    <p class="p-two">截取网页后，及时上传至区块链 ，即可永久固定证据</p>
                    <!--                    <img class="banner-content-img" src="./images/banner.png"/>-->
                    <div class="search-group">
                        <input v-model="url" :disabled="urlDisabled"  @keyup.enter="urlEnter" type="text" placeholder="请输入取证链接，回车可输入多条链接，最多10条"/>
<!--                        <Select class="multiple_select" :transfer="true" transfer-class-name="multiple_select_transfer"-->
<!--                                v-model="url"-->
<!--                                filterable-->
<!--                                multiple-->
<!--                                :allow-create="!showTip"-->
<!--                                :not-found-text="this.url.length>=10 ? '最多输入10个侵权链接' : '请输入正确的目标网址'"-->
<!--                                placeholder="输入您要取证的目标网址，如 https://www.baidu.com；"-->
<!--                                @on-query-change="queryChange">-->
<!--                            <Option v-for="(item,index) in obtainEvidenceData" :value="item" :key="index">{{ item }}</Option>-->
<!--                        </Select>-->
                        <input @click="showPayWay" id="addButton" type="button" value="开始取证"/>
                    </div>
                    <ul v-if="obtainEvidenceData && obtainEvidenceData.length>0" class="obtain_evidence_group">
                        <li class="obtain_evidence_item" v-for="(item,index) in obtainEvidenceData" :key="index">
                            <Tooltip max-width="440" :content="item">
                                <span class="obtain_evidence_item_content">{{item}}</span>
                            </Tooltip>
                            <img @click="removeUrl(index)" class="obtain_evidence_item_close" src="@/views/vipClip/vip/lawcomponent/images/ty_close.png" alt='版权登记'>
                        </li>
                    </ul>
<!--                    <p style="font-size:12px;color:#f00;margin-top:5px" v-if="showTip">请输入正确的目标网址</p>-->
                </div>
            </div>
        </div>
        <!--    会员续费    -->
        <myczPay v-if="myczPayState" mywidth='838' myheight="585" myTitleheight="50" @fatherModal="myczPayFuc"/>
        <!--    加油包    -->
        <monitorBag bizType="03" v-if="monitorBagState" @monitorBagFather="monitorBagFuc"/>
        <generalframe myheight="450" mywidth="800" @fatherMethod="showDialog = false" v-show="showDialog"
                      :maintitle=" obtainEvidenceData && obtainEvidenceData.length >1 ? '确认进行批量取证' : '网页取证' " ref="mychild">
            <div style="margin-top: 30px;font-size: 15px;" v-if="obtainEvidenceData && obtainEvidenceData.length >1">您一共选择{{ obtainEvidenceData.length }}个侵权链接，会扣除{{ obtainEvidenceData.length }}次取证次数</div>
            <div style="display: flex; margin-top: 30px; min-height: 200px">
                <div style="width: 150px; line-height: 42px;">支付方式：</div>
                <div>
                    <component :is="PayWayCom" :batchNum="obtainEvidenceData.length" @onselected="payWay = $event" type="03"></component>
                </div>
            </div>
            <input @click="submitEvidence" :disabled="disabled" class="submit-button" type="button" value="确定"/>
        </generalframe>
    </div>
</template>

<script>
    import {_saveWebpage, _getresave} from "@/api/evidence.js";
    import Cookies from "js-cookie";
    import $ from 'jquery';
    import myczPay from '@/views/vipClip/vip/lawcomponent/myczpay';
    import monitorBag from '@/views/vipClip/monitor/components/monitorBag';
    import generalframe from '@/views/vipClip/vip/lawcomponent/generalframe.vue'
    import payWay from '@/views/main-components/pay-way';
    import {router} from "../../../router";

    export default {
        metaInfo: {
            title: '网页取证|版权服务专家|版权家',
            meta: [{                 // set meta
                name: 'keyWords',
                content: '版权服务,版权百科,版权,版权家,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
            }, {
                name: 'Description',
                content: '网页取证,版权家,人人都是创作者，人人都是版权人。版权家秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
            }]
        },
        name: "evidenceWeb",
        components: {
            monitorBag,
            myczPay,
            generalframe,
            payWay,
        },
        data() {
            return {
                url: "",
                showTip: false,
                orderSeqNo: "",
                myczPayState: false, //会员续费
                monitorBagState: false, //加油包
                showDialog: false,
                payWay: null,
                disabled: false,
                PayWayCom: '',
                obtainEvidenceData:[],
                urlDisabled:false
            }
        },
        methods: {
            saveWebpage() {
                let userInfo = Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : '';
                console.log(userInfo)
                if (this.url && this.url.indexOf("http") == 0) {
                    this.showTip = false;
                    $("#addButton").attr("disabled", "disabled");

                    if (this.$route.query.id) {
                        _getresave({orderSeqNo: this.orderSeqNo}).then(res => {
                            if (res.code == 200) {
                                this.$router.push('/evidence-list')
                            } else {
                                toast(res.message)
                                $("#addButton").removeAttr("disabled");
                            }
                        });
                    } else {
                        const data = {
                            url: this.url,
                            registerId: userInfo && userInfo.id ? userInfo.id : '',
                        }
                        _saveWebpage(data).then(res => {
                            if (res.code == 200) {
                                this.$router.push('/evidence-list')
                            } else if (res.code == 214) {
                                toast("请购买会员后使用功能")
//                  if(userInfo.accountType=="person" ){
//                    this.$router.push('/vipPersonal')
//                  }else{
//                    this.$router.push('/vipEnterprise')
//                  }
                                this.$router.push({path: '/huiyuan.html'})
                            } else if (res.code == 215) {
                                toast("VIP已到期，请续费")
                                this.myczPayState = true;
                                $("#addButton").removeAttr("disabled");
                            } else if (res.code == 216) {
                                //toast("剩余次数不足，请购买加油包")
                                this.monitorBagState = true;
                                $("#addButton").removeAttr("disabled");
                            } else if (res.code == 213) {
                                toast("请实名认证后使用功能")
                                if (userInfo.accountType == "person") {
                                    this.$router.push('/authentication')
                                } else {
                                    this.$router.push('/authentication')
                                }
                            } else {
                                toast(res.message)
                                $("#addButton").removeAttr("disabled");
                            }
                        });
                    }

                } else {
                    this.showTip = true;
                    $("#addButton").removeAttr("disabled");
                }

            },
            //会员续费
            myczPayFuc() {
                this.myczPayState = false;
            },
            //加油包
            monitorBagFuc() {
                this.monitorBagState = false;
            },
            showPayWay() {
                let _this = this
				let nowUrl = _this.url;
				let obtainEvidenceData = _this.obtainEvidenceData;
				if(nowUrl && nowUrl.indexOf("http") == 0){
				    if(obtainEvidenceData.indexOf(nowUrl) == -1){
				        obtainEvidenceData.push(nowUrl)
						_this.url = '';
				    }
				    else{
				        toast('该目标网址已添加，请核对提交')
						return false
				    }
				    _this.obtainEvidenceData = obtainEvidenceData;
				}
				console.log(this.obtainEvidenceData);
				console.log(this.url);
                if (this.obtainEvidenceData && this.obtainEvidenceData.length>0) {
                    let userInfo = Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : '';
                    if (!userInfo || userInfo == '') {
                        _this.$store.state.app.showLoginOrRegistter = true;
                        return false;
                    }
                    this.showTip = false;
                    // $("#addButton").attr("disabled","disabled");
                    this.showDialog = true
                    this.PayWayCom = 'payWay'
                }  else {
                    toast('请添加目标网址后，再提交')
                    this.showTip = true;
                    //  $("#addButton").removeAttr("disabled");
                }
            },
            submitEvidence() {
                console.log(this.payWay);
                this.disabled = true
                if (this.$route.query.id) {
                    _getresave({orderSeqNo: this.orderSeqNo}).then(res => {
                        if (res.code == 200) {
                            this.$router.push('/evidence-list')
                        } else {
                            toast(res.message)
                            this.disabled = false;
                        }
                    });
                } else {
                    let userInfo = Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : '';
                    console.log(userInfo)
                    const data = {
                        urls: JSON.stringify(this.obtainEvidenceData) ,
                        registerId: userInfo && userInfo.id ? userInfo.id : '',
                    }
                    if (this.payWay && this.payWay.gift.countNumber < this.obtainEvidenceData.length || !this.payWay) {
                        toast('无可用次数')
                        this.disabled = false;
                        return false;
                    } else {
                        if (this.payWay.gift.activityGiftId) {
                            Object.assign(data, {activityGiftId: this.payWay.gift.activityGiftId})
                        }
                    }
                    _saveWebpage(data).then(res => {
                        if (res.code == 200) {
                            this.$router.push('/evidence-list')
                        } else if (res.code == 214) {
                            toast("请购买会员后使用功能")
//                if(userInfo.accountType=="person" ){
//                  this.$router.push('/vipPersonal')
//                }else{
//                  this.$router.push('/vipEnterprise')
//                }
                            this.$router.push({path: '/huiyuan.html'})
                        } else if (res.code == 215) {
                            toast("VIP已到期，请续费")
                            this.myczPayState = true;
                            this.disabled = false;
                        } else if (res.code == 216) {
                            //toast("剩余次数不足，请购买加油包")
                            this.monitorBagState = true;
                            this.disabled = false;
                        } else if (res.code == 213) {
                            toast("请实名认证后使用功能")
                            if (userInfo.accountType == "person") {
                                this.$router.push('/authentication')
                            } else {
                                this.$router.push('/authentication')
                            }
                        } else {
                            toast(res.message)
                            this.disabled = false;
                        }
                    });
                }
            },

            //输入框回车事件
            urlEnter(e) {
                this.checkObtainEvidence();
            },
            //检查url事件
            checkObtainEvidence(){
                // let urlRule = /[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\.?/;
                let nowUrl = this.url;
                let obtainEvidenceData = this.obtainEvidenceData;
                if(obtainEvidenceData.length>=10){
                    toast('批量取证，一次最多可选择十个');
                    return
                }

                if(nowUrl && nowUrl.indexOf("http") == 0){
                    if(obtainEvidenceData.indexOf(nowUrl) == -1){
                        obtainEvidenceData.push(nowUrl)
                        this.url = '';
                    }
                    else{
                        toast('该目标网址已添加，请核对提交')
                    }

                    this.obtainEvidenceData = obtainEvidenceData;
                }
                else{
                    toast('请输入正确的目标网址')
                }
            },

            //删除url事件
            removeUrl(index){
                console.log(index)
                let obtainEvidenceData = this.obtainEvidenceData;
                obtainEvidenceData.splice(index, 1);
                this.obtainEvidenceData = obtainEvidenceData;
            },




            queryChange(e) {
                if (this.url.length >= 10) {
                    this.showTip = true;
                    return
                }
                if (e && e.indexOf("http") == 0) {
                    this.showTip = false
                } else {
                    this.showTip = true
                }

            },

        },
        created() {
            //  this.url = localStorage.getItem("evidence_web")? JSON.parse(localStorage.getItem("evidence_web")).url : ''
            //  console.log(JSON.parse(localStorage.getItem("evidence_web")).url)
            if (this.$route.query.id) {
                this.getRequest('/evidenceWebpage/get/' + this.$route.query.id).then(res => {
                    if (res.code == 200) {
                        this.url = res.result.url;
                        this.orderSeqNo = res.result.orderSeqNo;
                    }
                })
            } else if (this.$route.query.url) {
                // this.url = this.$route.query.url
                let obtainEvidenceData = this.obtainEvidenceData;

                obtainEvidenceData.push(this.$route.query.url);
                this.obtainEvidenceData = obtainEvidenceData;
            }
        },
        watch: {
            'url': {
                handler: function () {
                    // let urlRule = /[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\.?/;

                    if (this.url && this.url.indexOf("http") == 0) {
                        this.showTip = false
                    } else {
                        this.showTip = true
                    }
                }
            },
        },

    };
</script>

<style scoped lang="less">
    .submit-button {
        width: 230px;
        height: 42px;
        background: rgba(255, 216, 0, 1);
        border-radius: 4px;
        line-height: 42px;
        font-size: 14px;
        font-weight: 600;
        color: rgba(78, 78, 78, 1);
        cursor: pointer;
        border: none;
        outline: none;
    }

    .banner {
        width: 100%;
        /*height: 460px;*/
        background: rgba(0, 0, 0, 1);

        .banner-background {
            /*height: 460px;*/
            background: url("./images/bg.png") no-repeat;
            background-size: cover;
            background-position: center;

            .banner-content {
                width: 1334px;
                min-height: 660px;
                margin: 0 auto;
                /*position: relative;*/
                overflow: hidden;
                background: url(./images/banner.png) no-repeat right center;
                background-size: 766px 437px;
                background-position: 517px 22px;

                .p-one {
                    font-size: 30px;
                    font-weight: bold;
                    color: rgba(255, 255, 255, 1);
                    line-height: 42px;
                    margin: 138px 0px 10px;
                }

                .p-two {
                    font-size: 20px;
                    font-weight: 400;
                    color: rgba(255, 255, 255, 1);
                    line-height: 28px;
                    margin-bottom: 44px;
                }

                .banner-content-img {
                    width: 766px;
                    height: 437px;
                    position: absolute;
                    top: 22px;
                    left: 517px;
                }

                .search-group {
                    width: 620px;
                    height: 60px;
                    background: rgba(255, 255, 255, 1);
                    border-radius: 2px;
                    border: 1px solid rgba(207, 207, 207, 1);
                    display: flex;
                    justify-content: center;
                    position: relative;
                    z-index: 200;

                    input {
                        border: none;
                        outline: none;
                    }

                    input:first-child {
                        width: 503px;
                        text-indent: 15px;
                    }

                    input:last-child {
                        width: 116px;
                        height: 58px;
                        background: rgba(255, 216, 0, 1);
                        border-radius: 0px 1px 1px 0px;
                        font-size: 14px;
                        font-weight: bold;
                        color: rgba(51, 51, 51, 1);
                        line-height: 58px;
                        cursor: pointer;
                    }

                    input::-webkit-input-placeholder { /* WebKit, Blink, Edge */
                        color: rgba(153, 153, 153, 1);
                        font-size: 14px;
                    }

                    input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
                        color: rgba(153, 153, 153, 1);
                        font-size: 14px;
                    }

                    input::-moz-placeholder { /* Mozilla Firefox 19+ */
                        color: rgba(153, 153, 153, 1);
                        font-size: 14px;
                    }

                    input:-ms-input-placeholder { /* Internet Explorer 10-11 */
                        color: rgba(153, 153, 153, 1);
                        font-size: 14px;
                    }
                }
            }
        }
    }

    .multiple_select {
        min-height: 58px;
        width: 503px;

        /deep/ &.ivu-select-multiple .ivu-select-input {
            width: 100% !important;
            height: 58px;
            border: 0;
        }


    }

    /deep/ .ivu-select-default.ivu-select-multiple .ivu-select-selection {
        min-height: 58px;
        border: 0;
        border-radius: 0;
        box-shadow: none;
    }

    .obtain_evidence_group{
        width: 503px;
        background: #fff;
        padding: 20px;
        list-style: none;
        margin-bottom: 20px;

        .obtain_evidence_item{
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;

            &:last-child{
                padding-bottom: 0;
            }

            .obtain_evidence_item_content{
                max-width: 440px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                display: inline-block;
            }

            .obtain_evidence_item_close{
                display: block;
                width: 18px;
                height: 18px;
                cursor: pointer;
            }
        }
    }


</style>
